import { api } from '@/lib/axios'
import type { LoginResponseDto } from './response'
import type { LoginRequestDto } from './request'
import type { AuthUser } from '@/stores/auth/types'

export function toLoginRequestDto(email: string, password: string): LoginRequestDto {
  return { email, senha: password }
}

export function toAuthUser(response: LoginResponseDto): AuthUser {
  return {
    id: response.id,
    displayName: response.displayName,
    givenName: response.givenName,
    surname: response.surname,
    mail: response.mail,
    jobTitle: response.jobTitle,
  }
}

export const authService = {
  login: async (email: string, password: string): Promise<LoginResponseDto> => {
    const dto = toLoginRequestDto(email, password)
    const { data } = await api.post<LoginResponseDto>('/Auth', dto)
    return data
  },
}
